import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import WhySection from './components/WhySection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedProducts from './components/FeaturedProducts';
import ArticlePreview from './components/ArticlePreview';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'YOYBUY Finds',
  'url': typeof import.meta !== 'undefined' && import.meta.env.VITE_SITE_URL ? import.meta.env.VITE_SITE_URL : 'https://yoybuyfinds.mom',
  'description': 'Curated подборки товаров из Китая. Лучшие находки, сравнение цен, готовые spreadsheet таблицы для умного шопинга через YOYBUY и агентов.',
  'inLanguage': 'ru',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': {
      '@type': 'EntryPoint',
      'urlTemplate': (typeof import.meta !== 'undefined' && import.meta.env.VITE_SITE_URL ? import.meta.env.VITE_SITE_URL : 'https://yoybuyfinds.mom') + '/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <WhySection />
        <CategoryGrid />
        <FeaturedProducts />
        <ArticlePreview />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}